import { defineComponent, computed, createBlock, openBlock, mergeProps, createSlots, withCtx, createTextVNode, createCommentVNode, toDisplayString, createElementBlock, createVNode, createElementVNode, unref, Fragment, renderList } from 'vue';
import LinkIcon from './basler-components.es609.js';
import _sfc_main$4 from './basler-components.es70.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es75.js';
/* empty css                       */
import _sfc_main$5 from './basler-components.es81.js';
/* empty css                       */
import _sfc_main$7 from './basler-components.es110.js';
/* empty css                        */
import _sfc_main$3 from './basler-components.es125.js';
/* empty css                        */
import _sfc_main$6 from './basler-components.es129.js';
import _sfc_main$2 from './basler-components.es87.js';
/* empty css                       */

const _hoisted_1 = ["datetime", "title"];
const _hoisted_2 = {
  key: 5,
  class: "teaser-card__title card__title"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { key: 7 };
const _hoisted_5 = { key: 8 };
const _hoisted_6 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TeaserCard",
  props: {
    header: {},
    content: {},
    headerGutter: { type: Boolean, default: false },
    headline: {},
    footer: { default: "" },
    badge: {},
    badgeStyle: { default: "primary" },
    date: {},
    link: {},
    linkIconPosition: { default: "content" },
    tagList: {},
    maxColumns: { default: 3 },
    isLoading: { type: Boolean, default: false },
    loadingLines: { default: 3 },
    teaserCardDataAttributes: {}
  },
  setup(__props) {
    const props = __props;
    const useCols = computed(() => {
      if (props.maxColumns === 1 || props.maxColumns === 2) {
        return [6, 6, 12];
      }
      return [4, 4, 12];
    });
    const cardDataAttributesWithPrefix = computed(() => {
      const cardDataAttributes = props.teaserCardDataAttributes ?? {};
      const result = {};
      Object.keys(cardDataAttributes).forEach((key) => {
        result[`data-${key}`] = cardDataAttributes[key];
      });
      return result;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, mergeProps({
        class: ["card--teaser", "teaser-card", { "teaser-card--is-loading": _ctx.isLoading }],
        "header-gutter": _ctx.headerGutter,
        "has-link-behavior": _ctx.link ? true : void 0
      }, cardDataAttributesWithPrefix.value), createSlots({
        default: withCtx(() => [
          _ctx.badge && _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$2, {
            key: 0,
            class: "teaser-card__loading-badge"
          })) : _ctx.badge ? (openBlock(), createBlock(_sfc_main$4, {
            key: 1,
            size: "small",
            "is-rounded": true,
            "badge-style": _ctx.badgeStyle,
            class: "teaser-card__badge"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.badge), 1)
            ]),
            _: 1
          }, 8, ["badge-style"])) : createCommentVNode("", true),
          _ctx.date && _ctx.date.date && _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$2, {
            key: 2,
            class: "teaser-card__loading-date"
          })) : _ctx.date ? (openBlock(), createElementBlock("time", {
            key: 3,
            class: "teaser-card__date",
            datetime: _ctx.date?.dateIso ? _ctx.date?.dateIso : void 0,
            title: _ctx.date?.title ? `${_ctx.date?.title} ${_ctx.date.date}` : void 0
          }, [
            createVNode(_sfc_main$5, {
              name: "calendar",
              class: "teaser-card__date-icon"
            }),
            createTextVNode(" " + toDisplayString(_ctx.date.date), 1)
          ], 8, _hoisted_1)) : createCommentVNode("", true),
          _ctx.headline && _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$2, {
            key: 4,
            class: "teaser-card__loading-headline"
          })) : _ctx.headline ? (openBlock(), createElementBlock("h4", _hoisted_2, [
            createVNode(_sfc_main$6, mergeProps(_ctx.link, {
              "is-renderless": true,
              class: "teaser-card__title-link"
            }), {
              default: withCtx(() => [
                createElementVNode("span", { innerHTML: _ctx.headline }, null, 8, _hoisted_3),
                _ctx.link && _ctx.linkIconPosition === "title" ? (openBlock(), createBlock(unref(LinkIcon), {
                  key: 0,
                  class: "teaser-card__link-icon"
                })) : createCommentVNode("", true)
              ]),
              _: 1
            }, 16)
          ])) : !_ctx.headline && _ctx.link ? (openBlock(), createBlock(_sfc_main$6, mergeProps({ key: 6 }, _ctx.link, {
            "is-renderless": true,
            class: "teaser-card__title-link"
          }), null, 16)) : createCommentVNode("", true),
          _ctx.content && _ctx.isLoading ? (openBlock(), createElementBlock("p", _hoisted_4, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.loadingLines, (index) => {
              return openBlock(), createBlock(_sfc_main$2, {
                class: "teaser-card__loading-content",
                key: index
              });
            }), 128))
          ])) : _ctx.content ? (openBlock(), createElementBlock("p", _hoisted_5, [
            createElementVNode("span", { innerHTML: _ctx.content }, null, 8, _hoisted_6),
            _ctx.link && _ctx.linkIconPosition === "content" ? (openBlock(), createBlock(unref(LinkIcon), {
              key: 0,
              class: "teaser-card__link-icon"
            })) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ]),
        footer: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.footer) + " ", 1),
          _ctx.tagList && _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$2, {
            key: 0,
            class: "teaser-card__loading-tags"
          })) : _ctx.tagList ? (openBlock(), createBlock(_sfc_main$3, {
            key: 1,
            tags: _ctx.tagList.tags,
            "is-small": _ctx.tagList.isSmall,
            "is-not-wrapped": _ctx.tagList.isNotWrapped ?? false,
            "style-type": "secondary"
          }, null, 8, ["tags", "is-small", "is-not-wrapped"])) : createCommentVNode("", true)
        ]),
        _: 2
      }, [
        _ctx.header ? {
          name: "header",
          fn: withCtx(() => [
            _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$2, {
              key: 0,
              class: "teaser-card__loading-media"
            })) : (openBlock(), createBlock(_sfc_main$7, {
              key: 1,
              media: _ctx.header,
              cols: useCols.value,
              lazyload: true
            }, null, 8, ["media", "cols"]))
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["class", "header-gutter", "has-link-behavior"]);
    };
  }
});

export { _sfc_main as default };
